import api from "@modules/api/api";
import { useMutation } from "@tanstack/react-query";

type SendRequest = {
  id: string;
  locale: string;
  refereeProvinceAbbr: string;
  hasGivenMarketingConsent: boolean;
};

const postMethod = async (sendReferralRequest: SendRequest) => {
  const { id, locale, ...request } = sendReferralRequest;

  await api.rawPost(
    `api/private-bill-of-sales/${id}/send-warranty-referral-email`,
    {
      json: request,
      headers: { "Accept-Language": locale },
    }
  );
};

export default function useSendWarrantyReferralEmailMutation() {
  return useMutation({ mutationFn: postMethod });
}
